export default {
  GET_CONTACTS_TABLE_LIST: state => state.contacts,
  GET_CONTACTS_TABLE_LIST2: state => state.contacts2,
  GET_CONTACT_AGENT: state => state.allagents,
  GET_ALL_CONTACTS: state => state.allContacts,
  GET_ALL_CONTACT_CONTRACTS: state => state.allContactContracts,
  GET_CONTACT_CARD_LIST: state => state.contactsCard,
  GET_REPORT_LIST: state => state.reportList,
  GET_REPORT_ONE: state => state.reportOne,
}
